import React from 'react';
import styles from './ScoreRules.module.css';

const ScoreRules = () => {
    return (
        <div className={styles.scoreRulesContainer}>
            <h1>Zasady punktacji w turniejach jednodniowych BTT</h1>

            <div className={styles.scoreRulesText}>

                <h5>Set do 4 wygranych gemów </h5>
                <p>Pierwsze dwa sety rozgrywane są do 4 wygranych gemów</p>

                <h5>Tiebreak w pierwszych dwóch setach</h5>
                <p>Przy statnie 3:3 w pierwszym i drugim secie, rozgrywany jest tiebreak do 7 pkt, z zachowaniem dwu-punktowej
                    przewagi.</p>

                <h5>3 set - duży tiebreak</h5>
                <p>Trzecim, rozstrzygającym setem jest tiebreak rozgrywany do 10 pkt, z zachowaniem dwu-punktowej
                    przewagi.</p>

                <h5>Gramy bez przewag</h5>
                <p>Przy stanie równowagi w gemie, rozgrywany jest punkt rozstrzygający, przy założeniu, że w meczu
                    deblowym stronę podania wybierają odbierający,
                    natomiast w meczu singlowym kierunek serwisu wybiera podający.
                </p>

                <h5>Dodatkowa punktacja w meczach "każdy z każdym"</h5>
                <p className={styles.nextRow}>2 pkt. za wygranie meczu 2:0,</p>
                <p className={styles.nextRow}>1 pkt. za przegranie meczu 1:2,</p>
                <p className={styles.nextRow}>0 pkt. za przegranie meczu 0:2.</p>
                <p>W drugiej kolejności liczy się różnica pomiędzy gemami wygranymi i przegranymi. Punkty
                    tiebreaka trzeciego seta przeliczane są proporcjonalnie
                    do liczby gemów w secie, np. jeżeli pierwsze dwa sety toczą się do 4 wygranych gemów, to 10 pkt tiebreka
                    przeliczana jest na 4 pkt. </p>
                <p>W przypadku, gdy dwóch graczy posiada równą liczby punktów oraz ten sam wynik różnicy gemów wygranych
                    i przegranych, decyduje bezpośredni wynik meczu pomiędzy nimi.</p>
            </div>
        </div>
    );
};

export default ScoreRules;